module.exports = __webpack_public_path__ + "img/not-available.30ccdb2c.svg";